import SLIDER from '../modules/slider';
import GET_ARTICLES from '../plugins/getArticles'

const [ w, d, mq ] = [ window, document, window.matchMedia('(max-width: 900px)') ]

const slider = new SLIDER();

const jqReady = () => {

  // ロゴ変更
  $.when( w.load['header'] ).then( () => {
    $('[data-top-src]').each( function(){
      this.src = this.dataset.topSrc;
      this.width = this.dataset.topWidth;
    });
  });
  
  // スライダー
  $.when( w.load['mainvisual'] ).then(() => {
    slider.init();
    $('[data-plugin="getSiteH1"]').getSiteH1();
  });

  $(w).on('load', () => {
    $.when( w.load['mainvisual'] ).then(() => slider.start() );
  });

  // information
  $.when(w.load['block-information']).then( () => {
    let makeItem = item => $(`
      <li class="block-information-item">
        <a href="${item.href}">
          <div class="block-information-item__body">
            <span class="cate">${item.category.name}</span>
            <span class="date">${item.date}</span>
            <span class="subject">${item.title.str_truncate(35)}</span>
            ${item.is_new ? '<b class="new">NEW</b>': ''}
            <svg class="icon" width="16" height="16"><use href="/asset/svg/sprite.symbol.svg#icon-circle-right"></use></svg>
          </div>
        </a>
      </li>
    `)[0]
    GET_ARTICLES('.block-information__list[data-plugin="getArticles"]', { makeItem })
  })

}

export default function HOME() {
  $( jqReady )
}